import { useEffect, useState } from "react";
import { requestRaffleHistory } from "@/apps/raffle/services/raffleApi";
import { RaffleHistoryResponse } from "@/apps/raffle/types";
import { useRaffleHistoryStore } from "@/apps/raffle/store/raffleHistoryStore";

export const useRaffleHistory = (yandexId: string | null) => {
  const getCachedHistory = useRaffleHistoryStore((state) => state.getHistory);
  const cacheHistory = useRaffleHistoryStore((state) => state.setHistory);
  const [history, setHistory] = useState<RaffleHistoryResponse | null>(() => {
    return getCachedHistory(yandexId);
  });
  const [isLoading, setIsLoading] = useState(() => {
    return !getCachedHistory(yandexId);
  });

  useEffect(() => {
    let isCurrentRequest = true;

    const loadHistory = async () => {
      if (!yandexId) {
        setHistory(null);
        setIsLoading(false);
        return;
      }

      const cachedHistory = getCachedHistory(yandexId);

      if (cachedHistory) {
        setHistory(cachedHistory);
        setIsLoading(false);
      } else {
        setIsLoading(true);
      }

      try {
        const data = await requestRaffleHistory(yandexId);

        if (isCurrentRequest) {
          setHistory(data);
          cacheHistory(yandexId, data);
        }
      } catch {
        if (isCurrentRequest) {
          setHistory(cachedHistory);
        }
      } finally {
        if (isCurrentRequest) {
          setIsLoading(false);
        }
      }
    };

    loadHistory();

    return () => {
      isCurrentRequest = false;
    };
  }, [cacheHistory, getCachedHistory, yandexId]);

  return {
    history,
    isLoading,
  };
};
